import { SplineChartV2Series } from 'src/components/BeaconV2Components/SplineChartV2';
import { weekIdToTimestamp } from 'src/components/BeaconV2Components/SplineChartV2/splineChartV2Utils';
import convertLineChartSeriesToDelimitedData, {
  Series
} from 'src/components/Charts/GenericChart/SeriesConverters/lineChart';

/**
 * Converts SplineChartV2 series data to CSV format.
 *
 * Mirrors the export behavior in `BeaconMetricSplineChart` so that prior-period and prior-year
 * comparisons render consistently across Atlas and Beacon:
 *   - Prior period (`isPriorPeriod = true`): comparison keeps its own actual timestamps, so it
 *     lands in different rows from primary (no misleading side-by-side alignment).
 *   - Prior year (default): comparison's x-values are aligned to primary by index, so both series
 *     share the same WeekEnding row.
 */
const convertSplineChartV2SeriesToDelimitedData = (
  primarySeries: SplineChartV2Series,
  comparisonSeries?: SplineChartV2Series,
  primaryDisplayName = 'Primary',
  comparisonDisplayName = 'Comparison',
  isPriorPeriod: boolean = false
): string => {
  const primaryData = primarySeries.data;
  const primaryDataForExport = primaryData.map((point) => ({
    x: weekIdToTimestamp(point.weekId) || 0,
    y: point.value ?? 0
  }));

  const seriesForLineChart: Series[] = [];

  if (comparisonSeries) {
    const comparisonDataForExport = comparisonSeries.data
      .map((point, index) => {
        if (isPriorPeriod) {
          return { x: weekIdToTimestamp(point.weekId) || 0, y: point.value ?? 0 };
        }
        const alignedX = primaryData[index]
          ? weekIdToTimestamp(primaryData[index].weekId) || 0
          : weekIdToTimestamp(point.weekId + 100) || 0;
        return { x: alignedX, y: point.value ?? 0 };
      })
      .filter((d) => d.x > 0);

    seriesForLineChart.push({
      type: 'spline',
      name: comparisonDisplayName,
      data: comparisonDataForExport
    } as unknown as Series);
  }

  seriesForLineChart.push({
    type: 'spline',
    name: primaryDisplayName,
    data: primaryDataForExport.filter((d) => d.x > 0)
  } as unknown as Series);

  return convertLineChartSeriesToDelimitedData(seriesForLineChart, isPriorPeriod);
};

export default convertSplineChartV2SeriesToDelimitedData;
